<template>
  <v-textarea
    v-model="inputText"
    :rows="calcRow"
    class="item_detail_text"
    solo
    background-color="rgba(255,255,255,0)"
    flat
    hide-details
  ></v-textarea>
</template>

<script>
export default {
  name: "CheckListItemEditableDetailText",
  data: () => ({}),
  computed: {
    inputText: {
      get() {
        return this.text;
      },
      set(value) {
        this.$emit("update:text", value);
      }
    },
    calcRow() {
      if (!this.inputText) {
        return;
      }
      return this.inputText.split(/\n/).length;
    }
  },
  methods: {},
  created() {},
  components: {},
  props: ["text"]
};
</script>

<style scoped>
.item_detail_text {
  border: 1px dashed #707f89;
  border-radius: 12px;
  color: #707f89;
  font-size: 12px;
  width: 90%;
  text-align: left;
  padding-left: 10px;
  background-color: #ffffff;
  padding: 0;
}
</style>
